import { useNavigate } from "react-router-dom";
import { LogOut, UserCircle } from "lucide-react";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuLabel, DropdownMenuSeparator, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";
import { useAuth } from "@/context/AuthContext";
import { ROLES } from "@/lib/format";
import { Sel } from "@/components/Field";
import { NotificationBell } from "./NotificationBell";
import { AssocLogo } from "./AssocLogo";

export const Header = () => {
  const { user, current, memberships, switchAssociation, logout } = useAuth();
  const nav = useNavigate();
  const initials = (user?.name || user?.email || "?").split(" ").map((x) => x[0]).join("").slice(0, 2).toUpperCase();

  return (
    <header data-testid="app-header" className="sticky top-0 z-20 bg-white/95 backdrop-blur border-b border-slate-200">
      <div className="flex items-center justify-between gap-3 h-16 lg:h-20 px-4 lg:px-8">
        <div className="flex items-center gap-3 lg:hidden min-w-0">
          <AssocLogo size="h-9 w-9" />
          <span className="font-heading font-bold text-slate-900 truncate">{current?.name}</span>
        </div>
        <div className="hidden lg:block w-72">
          {memberships.length > 1 ? (
            <Sel testId="association-switcher" value={current?.association_id} onChange={switchAssociation}
              options={memberships.map((m) => ({ value: m.association_id, label: m.name }))} />
          ) : (
            <span className="text-sm text-slate-600">Associazione: <strong className="text-slate-900">{current?.name}</strong></span>
          )}
        </div>
        <div className="flex items-center gap-1">
          <NotificationBell />
          <DropdownMenu>
            <DropdownMenuTrigger asChild>
              <button data-testid="user-menu" className="flex items-center gap-2 pl-2 rounded-lg hover:bg-slate-100 h-11 pr-2">
                <div className="h-9 w-9 rounded-full bg-slate-200 text-slate-700 font-semibold flex items-center justify-center text-sm">{initials}</div>
                <div className="hidden sm:block leading-tight text-left">
                  <div className="text-sm font-semibold text-slate-900">{user?.name}</div>
                  <div className="text-xs text-slate-500">{ROLES[current?.role]}</div>
                </div>
              </button>
            </DropdownMenuTrigger>
            <DropdownMenuContent align="end" className="w-56">
              <DropdownMenuLabel className="font-normal text-xs text-slate-500">{user?.email || (user?.username && `@${user.username}`)}</DropdownMenuLabel>
              {memberships.length > 1 && memberships.map((m) => (
                <DropdownMenuItem key={m.association_id} data-testid={`switch-assoc-${m.association_id}`} onClick={() => switchAssociation(m.association_id)}>
                  {m.name} {m.association_id === current?.association_id && "✓"}
                </DropdownMenuItem>
              ))}
              <DropdownMenuSeparator />
              <DropdownMenuItem data-testid="user-menu-profile" onClick={() => nav("/profilo")}><UserCircle className="h-4 w-4 mr-2" /> Il mio profilo</DropdownMenuItem>
              <DropdownMenuItem data-testid="user-menu-logout" onClick={logout}><LogOut className="h-4 w-4 mr-2" /> Esci</DropdownMenuItem>
            </DropdownMenuContent>
          </DropdownMenu>
        </div>
      </div>
    </header>
  );
};
